import styled from 'styled-components';
import { SlideOut } from '@interstate/components/SlideOut';
import { BreakPoint } from '@makemydeal/dr-activities-common';

export const StyledEditCustomerSlideOut = styled(SlideOut)`
    .ids-slideout-close-button {
        cursor: pointer;
    }
    .ids-slideout-title {
        flex: 1;
    }
    .MuiDrawer-paper {
        display: flex;
        flex-direction: column;
    }
    .ids-SlideOut-content {
        padding-bottom: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
    @media (max-width: ${BreakPoint.PHONE}) {
        .ids-SlideOut-content {
            padding-left: 1rem;
            padding-right: 1rem;
        }

        .ids-slideout-title-container {
            padding-left: 1rem;
        }
    }

    #ids-SlideOut-footer-customer-slide-out {
        padding-top: 10px;
    }
`;

export const CustomerTabsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const ToggleLabelWithIcon = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;

    svg {
        width: 1rem;
        height: 1rem;
    }
`;
